module.exports = __webpack_public_path__ + "img/circle_today.802a2747.svg";